document.addEventListener("DOMContentLoaded", () => {
  const data = {
    address: null,
    email: null,
    phoneNumber: null,
    plan: null,
  };

  window.quizData = data;

  const quiz = document.getElementById('quiz');
  const quizCloseButton = document.getElementById('quiz-close-button');
  const quizTriggers = document.querySelectorAll('.quiz-trigger');

  if (quizCloseButton) quizCloseButton.addEventListener('click', () => closeQuiz(data))
  quiz.addEventListener('click', (e) => e.stopPropagation());

  quizTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      showQuizPopup(data);
      showQuizStep1(data);
    });
  });

  const quizPopup = document.getElementById('quiz-popup');

  if (quizPopup) quizPopup.addEventListener('click', () => closeQuiz(data));

  initializeChargebeeProductTracking('cb-residential-standard-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-residential-advanced-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-travel-standard-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-travel-advanced-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')
});

const openQuiz = () => {
  const quiz = document.getElementById('quiz');
  const quizError = document.getElementById('quiz-error');
  const quizErrorMessage = document.getElementById('quiz-error-message');

  quizError.style.display = 'none';
  quizErrorMessage.innerText = 'An error occurred';
  quiz.style.display = 'flex';
}

const closeQuiz = (data) => {
  const quiz = document.getElementById('quiz');
  quiz.style.display = 'none';

  window.quizData.type = window.quizData.previousType;
  hideQuizPopup(data);
}

const showQuizStep1 = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2 = document.getElementById('quiz-step-2');

  quizStep2.style.display = 'none';
  quizStep1.style.display = 'flex';

  data.currentStep = 1;

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  quizMainHeading1.style.display = 'flex';

  const quizResidentialPlanCard = document.getElementById('quiz-step-1-residential-plan-card');
  const quizTravelPlanCard = document.getElementById('quiz-step-1-travel-plan-card');

  if (data.plan === 'travel') {
    quizResidentialPlanCard.style.display = 'none';
    quizTravelPlanCard.style.display = 'flex';
  } else {
    quizResidentialPlanCard.style.display = 'flex';
    quizTravelPlanCard.style.display = 'none';
  }

  const quiz = document.getElementById('quiz');
  quiz.scrollTo(0, 0);

  let quizStep1Submit = document.getElementById('quiz-step-1-submit');
  const quizError = document.getElementById('quiz-error');
  const quizErrorMessage = document.getElementById('quiz-error-message');

  const quizFormEmailField = document.getElementById('quiz-step-1-email');
  const quizFormSubmit = document.getElementById('quiz-button-container');
  quizFormEmailField.addEventListener('focus', (e) => {
    quizFormSubmit.scrollIntoView({ block: 'center', behavior: 'smooth' })
  })

  const quizFormPhoneField = document.getElementById('quiz-step-1-phone');
  quizFormPhoneField.addEventListener('keypress', (e) => {
    if (e.keyCode > 47 && e.keyCode < 58) {
      setTimeout(() => {
        let inputValue = e.target.value.replace(/\D/g, '');

        if (inputValue.length == 0) {
          inputStr = inputStr;
        } else if (inputValue.length < 4) {
          inputValue = '(' + inputValue;
        } else if (inputValue.length < 7) {
          inputValue = '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6);
        } else {
          inputValue =
            '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6) + '-' + inputValue.substring(6, 10);
        }

        e.target.value = inputValue;
      }, 100);
    } else {
      e.preventDefault();
    }
  })

  const quizStep1SubmitEventHandler = async (e) => {
    e.preventDefault();

    const emailInput = document.getElementById('quiz-step-1-email');
    const phoneInput = document.getElementById('quiz-step-1-phone');
    const zipInput = document.getElementById('quiz-step-1-zip');

    quizError.style.display = 'none';
    quizErrorMessage.innerText = 'An error occurred';

    data.email = emailInput.value.trim();
    data.phoneNumber = phoneInput.value.trim();
    data.zipCode = zipInput.value.trim();

    if (data.email === '') {
      quizErrorMessage.innerText = 'Please input email address'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    } else if (!validateEmail(data.email)) {
      quizErrorMessage.innerText = 'Please enter a valid email address'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (data.phoneNumber === '') {
      quizErrorMessage.innerText = 'Please input mobile number'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    let payload = {
      email: data.email,
      phone: data.phoneNumber,
      zip_code: data.zipCode,
      plan: data.plan,
      source: 'Popup',
      timestamp: new Date().toISOString(),
    };

    quizStep1Submit.innerHTML = '<div class="bar-loader"></div>';
    quizStep1Submit.disabled = true;

    let r = await fetch('https://app.lrlos.com/webhook/address-lookup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    quizStep1Submit.innerHTML = 'UNLOCK MY SAVINGS';
    quizStep1Submit.disabled = false;

    showQuizStep2(data);
  }

  const quizButtonContainer = document.getElementById('quiz-button-container-main');

  const buttonClone = quizStep1Submit.cloneNode(true);
  quizButtonContainer.innerHTML = '';
  quizButtonContainer.appendChild(buttonClone);

  quizStep1Submit = document.getElementById('quiz-step-1-submit');

  quizStep1Submit.addEventListener('click', quizStep1SubmitEventHandler, true);
}

const showQuizStep2 = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2 = document.getElementById('quiz-step-2');

  quizStep2.style.display = 'flex';
  quizStep1.style.display = 'none';

  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 2;

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  quizMainHeading1.style.display = 'none';

  const quizResidentialPlanCard = document.getElementById('quiz-step-2-residential-plan-card');
  const quizTravelPlanCard = document.getElementById('quiz-step-2-travel-plan-card');

  const quizStep2AddressText = document.getElementById('quiz-step-2-address-text');
  quizStep2AddressText.innerText = data.zipCode;

  if (data.plan === 'travel') {
    quizResidentialPlanCard.style.display = 'none';
    quizTravelPlanCard.style.display = 'flex';
  } else {
    quizResidentialPlanCard.style.display = 'flex';
    quizTravelPlanCard.style.display = 'none';
  }

  const quizPopupMain = document.getElementById('quiz');
  quizPopupMain.scrollTo(0, 0);
}
